import { compensaTheme, interriskTheme, tuwTheme } from '@sky-distribution/react-commons-ui';
import { Tenant } from './tenants';

export const themes = [
  {
    name: Tenant.COMPENSA,
    config: compensaTheme,
  },
  {
    name: Tenant.INTER_RISK,
    config: interriskTheme,
  },
  {
    name: Tenant.TUW,
    config: tuwTheme,
  },
];
